/* eslint-disable max-len */
import 'slick-carousel';

const $bodySelector = $('body');
const overflowHiddenClass = 'overflow-hidden';
const $ryobiOnePlusHeaderSelector = $('.ryobi-oneplus header');
const $ryobiOnePlusFooterSelector = $('.ryobi-oneplus footer');
const activeClass = 'is-active';

$('.js-op-carousel-nav').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  dots: false,
  centerMode: false,
  infinite: true,
  arrows: true,
  draggable: false,
  appendArrows: $('.js-op-carousel-nav'),
  prevArrow: '<button type="button" aria-label="Previous" class="carousel-nav carousel-nav__prev"><span class="sr-only">Previous</span><i class="fa fa-chevron-left"></i></button>',
  nextArrow: '<button type="button" aria-label="Next" class="carousel-nav carousel-nav__next"><span class="sr-only">Next</span><i class="fa fa-chevron-right"></i></button>',
  responsive: [{
    breakpoint: 770,
    settings: {
      arrows: true,
      slidesToShow: 2,
    },
  }, {
    breakpoint: 480,
    settings: {
      arrows: true,
      slidesToShow: 1,
    },
  }],
});


$('.js-op-carousel-nav .slick-slide').click(function click() {
  const $chosenSlide = $(this);

  $('.js-technologies-content-item').removeClass(activeClass);

  const index = $chosenSlide.data('slick-index');
  const $popup = $('.js-technologies-content-item').eq(index);
  $popup.addClass(activeClass);
  $ryobiOnePlusHeaderSelector.hide();
  $ryobiOnePlusFooterSelector.hide();
  $bodySelector.addClass(overflowHiddenClass);

  const video = $popup.find('video');
  const videoSrc = $popup.find('.js-hdn-video-src').val();

  if (video.length) {
    video.attr('src', videoSrc);
    video.get(0).play();
  }
});

$('.js-close-fullscreen').on('click tap', () => {
  $('.js-technologies-content-item').removeClass(activeClass);
  $ryobiOnePlusHeaderSelector.show();
  $ryobiOnePlusFooterSelector.show();
  $bodySelector.removeClass(overflowHiddenClass);
  $('video').each(function each() {
    $(this).get(0).pause();
  });
});
